module.exports = __webpack_public_path__ + "img/colissimo.2b86dccc.png";